import React, { Component } from 'react';
import '../IpPatientDetails.css';
import { Box, Stack, Grid, Typography, Paper, TextField, Autocomplete, Button, Tooltip} from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import { CommonPatientDetails, CommonPatientCard, CommonEditButton, CommonDeleteButton, CommonPopUp, DeletePopup, ConsultantPatientCard  } from "../../../../../Components/Common Components/CommonComponents";
import { Colors } from '../../../../../Styles/Colors';
import {getCachevalue, localGetItem} from "../../../../../Utility/Services/CacheProviderService";
import RestAPIService from "../../../../../Utility/Services/RestAPIService";
import {Serviceurls} from "../../../../../Utility/API/Serviceurls";
import { withTranslation } from 'react-i18next';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import {PainLevel} from '../../../../../Utility/Constants';
import { DateTime } from 'luxon';
import ToastMsg from '../../../../../Components/ToastMsg/ToastMsg';
import Loader from '../../../../../Components/Loader';
import { CommonGridToolBarWithButton } from '../../../../../Components/Common Components/CommonComponents';
// import Chart from "chart.js/auto";
// import { Line } from "react-chartjs-2";
import {ImagePaths} from '../../../../../Utility/ImagePaths';
import { CheckAccessFunc } from '../../../../../Components/CommonFunctions/CommonFunctions';
// const labels = ["January", "February", "March", "April", "May", "June"];

class PainChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ipPatientData: {},
      IPadmissionDetails: {},
      painChartList: [],
      pageSize: 10,
      painDate: new Date(),
      NurseList: [],
      nurseName: {
        "nurse": "",
        "staff_id": ""
      },
      painLevel: "",
      selectedID: "",
      deleteID: "",
      deletePopup: false,
      isViewChart: false,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: '',
      clinic_id: JSON.parse(localGetItem('SelectedDoctorClinicId')),
    }
    this.painChart = [
      { value: "(0-1)", image: ImagePaths.noPain.default },
      { value: "(1-3)", image: ImagePaths.mildPain.default },
      { value: "(3-4)", image: ImagePaths.moderatePain.default },
      { value: "(5-7)", image: ImagePaths.severePain.default },
      { value: "(7-9)", image: ImagePaths.verySevere.default },
      { value: "(9-10)", image: ImagePaths.worstPain.default },
    ];
  }
  componentDidMount() {
    let ipPatientData = getCachevalue("IppatientData")
    let patientData = JSON.parse(ipPatientData)
    this.setState({
      ipPatientData: patientData
    }, () => {
      this.getPatientData()
      this.GetNurseList()
      this.getPaintLevelList()
    })
  }
  
  GetNurseList = () => {
    try {
      let url = Serviceurls.FO_STAFF_LIST;
      if (this.props.is_From_IpNotes && this.state.clinic_id) {
        url = `${url}?clinic_id=${this.state.clinic_id}`
      }
        RestAPIService.getAll(url)
            .then((response) => {
                if (response.data.status === "success") {
                    this.setState({
                        NurseList: response.data.data
                    }, () => {
                      if (this.state.NurseList?.length && localGetItem("NurseId") && !this.state?.nurseName?.staff_id) {
                        let nurseId = JSON.parse(localGetItem("NurseId"))
                        let nurseData = this.state.NurseList.find((item) => item.staff_id === nurseId)
                        this.setState({
                          nurseName : nurseData
                        })
                      }
                    })
                }
            }).catch((error) => {
                if (error?.response?.data?.message) {
                    this.errorMessage(error.response.data.message)
                } else {
                    this.errorMessage(error.message)
                }
            })
    } catch (error) {
        this.errorMessage(error.message)
    }
}
  getPatientData = () => {
    let admission_id =   this.state.ipPatientData?.id 
    let url = `${(localGetItem('isNewBilling') === "false" ? Serviceurls.IP_PATIENT_DETAILS : Serviceurls.IP_PATIENT_DETAILS_NEW)}?admission_id=${admission_id}`;
    if (this.props.is_From_IpNotes && this.state.clinic_id) {
      url = `${url}&clinic_id=${this.state.clinic_id}`
    }
    try {
      RestAPIService.getAll(url)
        .then((response) => {
          if (response.data.status === "success") {
            this.setState({
              IPadmissionDetails: response.data.data[0]
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }
  getPaintLevelList = () => {
    try {
      var admission_id = this.state.ipPatientData?.id;
      let url = `${Serviceurls.IP_PAIN_CHART}?ip_admission_id=${admission_id}`;
      if (this.props.is_From_IpNotes && this.state.clinic_id) {
        url = `${url}&clinic_id=${this.state.clinic_id}`
      }
      const painLevel = {  
        "(0-1)": "No Pain",  
        "(1-3)": "Mild Pain",  
        "(3-4)": "Moderate",  
        "(5-7)": "Severe",  
        "(7-9)": "Very Severe",  
        "(9-10)": "Worst Pain Possible"  
    };
      RestAPIService.getAll(url)
          .then((response) => {
              if (response.data.status === "success") {
                const list = response.data.data?.map((item, index) => {
                  item["display_pain_level"] = `${item?.pain_level} ${painLevel[item?.pain_level] || ""}`;
                  item["sno"] = index + 1;
                  return item;
                })
                  this.setState({
                      painChartList: list
                  }, () => {
                    // var { painChartList } = this.state
                    // painChartList && painChartList.length > 0 && painChartList.forEach(data => { data.is_pain_level = false; });
                    // { painChartList && painChartList.length > 0 && painChartList.map((item, index) => {
                    //   var baseIndex = index - 1
                    //   var prevIndex = baseIndex == -1 ? 0 : baseIndex
                    //   if(+(painChartList[prevIndex].pain_level) > +(painChartList[index].pain_level)) {
                    //     painChartList[index].is_pain_level = true
                    //   } else {
                    //     painChartList[index].is_pain_level = false
                    //   }
                    //   this.setState({
                    //      painChartList
                    //   })
                    //  })
                    // }
                  })
                  
              }
          }).catch((error) => {
              if (error?.response?.data?.message) {
                  this.errorMessage(error.response.data.message)
              } else {
                  this.errorMessage(error.message)
              }
          })
    } catch (error) {
      this.errorMessage(error.message)
   }
  }
  deletePainLevel = () => {
   try { 
    RestAPIService.delete(Serviceurls.IP_PAIN_CHART + "?id=" + this.state.deleteID)
    .then((response) => {
      if (response.data.status === "success") {
          this.getPaintLevelList()
          this.handleClear()
          this.successMessage(response.data.message)
      }
     }).catch((error) => {
      this.errorMessage(error.message)
     })
    } catch (error) {
      this.errorMessage(error.message)
   }
  }
  onPressViewButton = (flag) => {
    this.setState({
      isViewChart: flag
    })   
  }
  gridToolBar = () => {
    return(
      <Box>
         <CommonGridToolBarWithButton onClickCommonButton = {this.onPressViewButton.bind(this)} ViewBtn = {false}/>
      </Box>

    )
  }
  renderLeftContent = () => {
    const { t } = this.props
    const painLevel = {
      "(0-1)": { image: ImagePaths.noPainSmile.default, color: "#75B23B", status: "No Pain" },
      "(1-3)": { image: ImagePaths.noPainSmile.default, color: "#75B23B", status: "Mild Pain" },
      "(3-4)": { image: ImagePaths.moderateSmile.default, color: "#FFCD05", status: "Moderate" },
      "(5-7)": { image: ImagePaths.severeSmile.default, color: "#F8981D", status: "Severe" },
      "(7-9)": { image: ImagePaths.verySevereSmile.default, color: "#F26A22", status: "Very Severe" },
      "(9-10)": { image: ImagePaths.worstPainsmile.default, color: "#DA1A32", status: "Worst Pain Possible" },
  };
    const columns = [
      { field: 'sno', sortable: false, headerName: t("SNo"), flex: 0.05 },
      {
        field: 'pain_chart_date', headerName: t("DateTime"), flex: 0.2, headerAlign: "center", align: "center",
        renderCell: (params) => {
          let startDate = params?.row?.pain_chart_date ? new Date(params.row.pain_chart_date) : ""
          let date = (this.state.painDate) ? DateTime.fromJSDate(startDate).toFormat("dd-MM-yyyy hh:mm a") : this.state.painDate
          return (<Box component={'div'}>{date ? (date) : '-'}</Box>)
        }
      },
      // {
      //   field: 'pain_level', headerName: t("PainLevel"), flex: 0.2, headerAlign: "center", align: "center",
      //   renderCell: (params) => { 
      //     return( 
      //      <Box component={'div'} sx = {{ display: "flex", flexDirection: "row" }}>
      //        <Typography> {params?.row?.pain_level ? (params?.row?.pain_level) : '-'}</Typography> 
      //        {params?.row?.pain_level ? 
      //         <Box sx = {{ marginLeft: "0.5vw" }}>
      //           { params?.row?.is_pain_level ? 
      //            <img className='emedhub_pain_range' src={ImagePaths.PainLowRange.default} /> :
      //            <img className='emedhub_pain_range' src={ImagePaths.PainHighRange.default} />
      //           }
      //         </Box> : null
      //       }
      //     </Box>)
      //   }
      // },
      {
        field: "display_pain_level", flex: 0.2, headerName: t("PainLevel"), headerAlign: "center", align: "center",
        renderCell: ({ row }) => {
          const painItem = painLevel[row?.pain_level];
          if (painItem) {
            const status = painItem.status.length > 10 ? `${painItem.status.substring(0, 10)}...` : painItem.status;
            return (painItem ? <Box component={'div'} sx={{ display: "flex", flexDirection: "row", gap: "0.5vw" }}>
              <Typography fontSize={'0.9vw'} sx={{ color: painItem.color }}> {row?.pain_level ? row?.pain_level : '-'}</Typography>
              <img className='emedhub_pain_range' src={painItem.image} />
              <Tooltip title={painItem.status.length > 10 ? painItem.status : null} arrow placement='top'>
                <Typography fontSize={'0.9vw'} sx={{ color: painItem.color }}> {status}</Typography>
              </Tooltip>
            </Box> : "-")
          } else {
            return (
              <Box component={'div'} sx={{ display: "flex", flexDirection: "row" }}>
                <Typography> {row?.pain_level ? (row?.pain_level) : '-'}</Typography>
                {row?.pain_level ?
                  <Box sx={{ marginLeft: "0.5vw" }}>
                    <img className='emedhub_pain_range' src={row?.is_pain_level ? ImagePaths.PainLowRange.default : ImagePaths.PainHighRange.default} />
                  </Box> : null
                }
              </Box>)
          }
        }
      },
      {
        field: 'nurse_name', headerName: t("NurseName"), flex: 0.2, headerAlign: "center", align: "center",
        renderCell: (params) => (<Box component={'div'}>{params?.row?.nurse_name ? (params?.row?.nurse_name) : '-'}</Box>)
      },
      {
        field: 'modified_user', headerName: t("UpdatedBy"), flex: 0.2, headerAlign: "center", align: "center",
        renderCell: (params) => (<Box component={'div'}>{params?.row?.modified_user ? (params?.row?.modified_user) : '-'}</Box>)
      },
      {
        field: 'action', headerName: "Action", flex: 0.2, headerAlign: "center", align: "center", sortable: false, hideable: false,
        renderCell: (params) => (<Box component={'div'}>
          <CommonEditButton size='1.5vw'
            disable={!CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Pain Chart", "SubTab").editAccess}
            onClick={() => {
              var nurseName = {
                "nurse": params.row.nurse_name,
                "staff_id": params.row.nurse_id
              }
              this.setState({
                painDate: params.row.pain_chart_date,
                painLevel: params.row.pain_level,
                nurseName: nurseName,
                selectedID: params.row.id
              })
            }} />
          <CommonDeleteButton
            disable={!CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Pain Chart", "SubTab").editAccess}
            onClick={() => {
              this.setState({
                deletePopup: true,
                deleteID: params.row.id
              })
            }} size='1.5vw' />
        </Box>)
      },
    ]
    return (
      <Box component={'div'} className='eMed_pain_left_card'>
        <DataGrid
          className='eMed_room_grid'
          rows={this.state.painChartList}
          columns={columns}
          getRowId={(row) => row.id}
          density='compact'
          disableSelectionOnClick = {true}
          pageSize={this.state.pageSize}
          onPageSizeChange={(newPageSize) => {
              this.setState({ pageSize: newPageSize })
          }}
          rowsPerPageOptions={[10, 20, 30]}
          pagination
          localeText={{
            toolbarColumns: "",
            toolbarDensity: "",
            toolbarExport: "",
            toolbarFilters: "",
            toolbarExportPrint: ""
          }}
          components={{
            Toolbar: this.gridToolBar,
            NoRowsOverlay: () => (
                <Stack className='eMed_conf_nodata'>
                    {t("NoRecordsFound")}
                </Stack>
            )
        }}
        />
      </Box>
    )
  }
  renderDateFilter = () => {
    const { t } = this.props
    const states = this.state;
    const currentDate = new Date();
    const admissionDate = states?.ipPatientData?.admitted_date
      ? new Date(states.ipPatientData?.admitted_date)
      : states?.ipPatientData?.admission_date
        ? new Date(states.ipPatientData?.admission_date)
        : currentDate;
    const dischargeDate = states.ipPatientData?.discharge_date && (new Date(states.ipPatientData?.discharge_date) <= currentDate) ?
      new Date(states.ipPatientData?.discharge_date) : currentDate;
      
    return(
      <Box>
          <Box component={'div'} sx={{ backgroundColor: Colors.ThemeLightColor, marginLeft: "1dvw", marginBottom: '0.5vw' }} className='eMed_DocNotes_DateTime' >
            <Typography marginLeft={'0.5vw'} color='#616161' fontWeight={'600'}>{t("DateTime")}</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateTimePicker
                inputFormat='DD-MM-YYYY & hh:mm:ss A'
                value={this.state.painDate}
                
                onChange={(newDate) => {
                  if (newDate === null) {
                    this.setState({ painDate: new Date() })
                  }
                  else if (newDate > new Date()) {
                    this.setState({ painDate: new Date() })
                  }
                  else {
                    this.setState({ painDate: newDate })
                  }
                }}
                // minDate={this.props?.IPadmissionDetails?.admitted_date}
              minDate={admissionDate}
              maxDate={dischargeDate}
                renderInput={(params) => <TextField size='small'
                  {...params}
                  fullWidth
                  variant='standard'
                  className='eMed_DocNotes_datePic_Textfield'
                  InputProps={{ 
                    ...params.InputProps, 
                    readOnly: true,
                    onKeyDown: (e) => e.preventDefault()
                  }}
                />}
              />
            </LocalizationProvider>
          </Box>
      </Box>  
    )
  }

  onImgClick = (value) => {
    this.setState((prevState) => ({
      ...prevState,
      painLevel: value
    }))
  }

  rendersmileBtn = (value, image, index) => {
    const isLastImage = index === this.painChart?.length - 1; 
    return (
      <Box key={index} position="relative" flex="1" textAlign="center">
        {/* Even Numbers (0, 2, 4, 6, 8, 10) → Above Image */}
        <Typography
          position="absolute"
          top="-3.5dvh"
          left="45%"
          transform="translateX(-50%)"
          fontSize="1vw"
          color="#616161"
        >
          {index * 2}
        </Typography>
  
        {/* Image */}
        <img
          src={image}
          onClick={() => this.onImgClick(value)}
          className={isLastImage ? "last_image" : ""}
          style={{
            cursor: "pointer",
            width: "100%",
            height: "13vw",
            backgroundColor: this.state.painLevel === value ? "#04B7B1" : "",
            objectFit: "cover",
            borderRight: "1px solid #E3E2E2"
          }}
          alt="smile"
        />
  
        {/* Odd Numbers (1, 3, 5, 7, 9) → Between Two Images */}
        {index < this.painChart.length - 1 && (
          <Typography
            position="absolute"
            top="-3.5dvh"
            left="95%"
            transform="translateX(-50%)"
            fontSize="1vw"
            color="#616161"
          >
            {index * 2 + 1}
          </Typography>
        )}
      </Box>
    );
  };
  renderSubContainer = () => {
    const { t } = this.props
    return(
       <Box className = 'emedhub_auto_complate'>
            {/* <Autocomplete className='emedhub_pain_level'
                size='small'
                options={PainLevel}
                getOptionLabel={(option) => option}
                value={this.state.painLevel}
                onChange={(event, newValue) => {
                    this.setState({
                      painLevel: newValue
                    })
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={t("PainManitory")}
                        placeholder={t("PainManitory")}
                    />
                )}
            />  */}
        <Typography className='eMed_pain_rgt_title' sx={{backgroundColor: "#FFFF", marginBottom: "0.5dvw"}}>{t("Pain Level")}</Typography>
        <Box display="flex" flexDirection="column" alignItems="center" width="100%"  padding="0.5dvw" marginBottom={"0.3dvw"} marginTop={"0.5dvw"}>
          <Box display="flex" width="100%" justifyContent="center" className = "eMed_painChart_container">
            {this.painChart.map((item, index) => this.rendersmileBtn(item.value, item.image, index))}
          </Box>
        </Box>
            <Autocomplete className='emedhub_Nurse_list'
                size='small'
                sx={{width: "100%"}}
                options={this.state.NurseList}
                getOptionLabel={(option) => option.nurse ? option.nurse : ""}
                value={this.state.nurseName}
                onChange={(event, newValue) => {
                    this.setState({
                        nurseName: newValue
                    })
                }}
                renderInput={(params) => (
                    <TextField
                        sx={{width: "30vw"}}
                        {...params}
                        label={t("NurseManitory")}
                        placeholder={t("NurseManitory")}
                    />
                )}
            />
       </Box>
    )
  }
  handleClickAdd = () => {
    var { t } = this.props
    try {
      let admission_id =   this.state.ipPatientData?.id 
      let startDate = new Date(this.state.painDate)
      let date = (this.state.painDate) ? DateTime.fromJSDate(startDate).toFormat("yyyy-MM-dd")  : this.state.painDate
      let Time= (this.state.painDate) ? DateTime.fromJSDate(startDate).toLocaleString(DateTime.TIME_24_WITH_SECONDS)  : this.state.painDate
      var data = {
            "id": this.state.selectedID ? this.state.selectedID : "",
            "ip_admission_id": admission_id,
            "nurse_id": this.state.nurseName.staff_id,
            "pain_date":(date + " " +Time),
            "pain_level": this.state.painLevel
      }
      if( this.state.painLevel == null) {
        this.errorMessage(t("InvalidPainLevel"))
      } else if (this.state.nurseName == null||( this.state.nurseName && (this.state.nurseName.staff_id) == "")) {
        this.errorMessage(t("InvalidNurseName"))
      }else if ( date == "Invalid DateTime") {
        this.errorMessage(t("Invalid Date and Time"))
      } else { 
       RestAPIService.create(data, Serviceurls.IP_PAIN_CHART)
        .then((response) => {
          if (response.data.status === "success") {
              this.getPaintLevelList()
              this.handleClear()
              this.successMessage(response.data.message)
          } else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
      }  
    }

    catch (error) {
    }
  
  }
  handleClear = () => {
    this.setState({
      nurseName: {
        "nurse": "",
        "staff_id": ""
      },
      painDate: new Date(),
      painLevel: "",
      selectedID: "",
      deleteID: "",
      deletePopup: false
    }, () => {
      if (this.state.NurseList?.length && localGetItem("NurseId")) {
        let nurseId = JSON.parse(localGetItem("NurseId"))
        let nurseData = this.state.NurseList.find((item) => item.staff_id === nurseId)
        this.setState({
          nurseName: nurseData
        })
      }
    })
  }
  renderRightContent = () => {
    const { t } = this.props
    return (
      <Paper component={'div'} className={'eMed_pain_right_card'}>
          <Typography component={'div'} fontWeight={600} color = {Colors.SecondaryText} className='eMed_pain_rgt_title'>{t("PainChart")}</Typography>
          <Box className = 'emedhub_pain_sub_container' sx={{overflowY: "auto", overflowX: "hidden"}}>
            {this.renderDateFilter()}
            {this.renderSubContainer()}
          </Box>
          <Stack spacing={2} direction="row" id='eMed_recPayment_rightBtnCon' sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center">
          <Button variant='outlined' size="small" id="eMed_recPayment_btn" onClick={() => { this.handleClear() }}>{t("Clear")}</Button>
          <Button variant='contained' size="small" id="eMed_recPayment_btn" disabled={this.state.BtnDisable || (!CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Pain Chart", "SubTab").editAccess)} onClick={() => {
            this.setState({
              BtnDisable: true
            }, () => { this.handleClickAdd() })
          }}>{t("Add")}</Button>
        </Stack>
      </Paper>          
    )
  }
  popupClose = () => {
    this.setState({
      deletePopup: false
    })
  }
  // renderChartComponent = () => {
  //  var { painChartList } = this.state
  //  var labels = []
  //  var chartData = []
  //  var lastPainLevel

  //  for( let i = 0; i < painChartList.length; i++ ) {  
  //   let start_date = new Date(painChartList[i].pain_chart_date)
  //   let date = DateTime.fromJSDate(start_date).toFormat("dd-MM-yyyy hh:mm a")
  //   labels.push(date)
  //   chartData.push(painChartList[i].pain_level)
  //   lastPainLevel = painChartList[i].pain_level
  //  }

  //  var labelColor

  //  if(lastPainLevel >= 8){

  //   labelColor = 'rgb(238,191,191)'

  //  }else if(lastPainLevel >= 6){

  //   labelColor = 'rgb(255,196,177)'

  //  }else if(lastPainLevel >= 4){

  //   labelColor = 'rgb(255,224,177)'

  //  }else if(lastPainLevel >= 2){

  //   labelColor = 'rgb(255,247,177)'

  //  }else{

  //   labelColor = 'rgb(179,255,195)'

  //  }

  //  var data = {
  //   "labels": labels,
  //   "title" : "Pain Cahrt",
  //   "datasets": [
      
  //     {
  //       label: "No Pain",
  //       backgroundColor: 'rgb(179,255,195)',
  //       borderColor: 'rgb(179,255,195)',
  //     },
  //     {
  //       label: "Mild Pain",
  //       backgroundColor: 'rgb(255,247,177)',
  //       borderColor: 'rgb(255,247,177)',
  //     },
  //     {
  //       label: "Moderate",
  //       backgroundColor:'rgb(255,224,177)',
  //       borderColor:'rgb(255,224,177)',
  //     },
  //     {
  //       label: "Severe / Very Severe",
  //       backgroundColor: 'rgb(255,196,177)',
  //       borderColor: 'rgb(255,196,177)',
  //     },
  //     {
  //       label: "Worst Pain",
  //       backgroundColor: 'rgb(238,191,191)',
  //       borderColor: 'rgb(238,191,191)',
  //     },
  //     {
  //       label: "",
  //       backgroundColor: Colors.white,
  //       borderColor: Colors.white,
  //     },
  //     {
  //       label: "",
  //       backgroundColor: Colors.white,
  //       borderColor: Colors.white,
  //     },
  //     {
  //       label: "Pain Level",
  //       backgroundColor: labelColor,
  //       borderColor: "rgb(187,0,0)",
  //       data: chartData 
  //     },
  //   ],
    
  // };

  // var options = {
  //   responsive: true,
  //   scales: {
  //     y: {
  //       min: 0,
  //       max: 10,
  //       stepSize: 1
  //     }
  //   },
  //   animations: {
  //     tension: {
  //       duration: 1000,
  //       easing: 'linear',
  //       from: 0.2,
  //       to: 0,
  //       loop: true
  //   }
  // },
  // plugins: {
  //   title: {
  //     display: true,
  //     text: 'Pain Chart'
  //   }
  // },

    

  // }
  // var chartBackground ={
  //   id: 'chartBackground',
  //   beforeDraw: (chart, args, pluginOptions) => {
  //     const {ctx, chartArea: {top, bottom, left, right, width, height}, scales: {x, y}} = chart;

  //     bgColor(10, 8, 'rgb(238,191,191)')
  //     bgColor(8, 6, 'rgb(255,196,177)')
  //     bgColor(6, 4, 'rgb(255,224,177)')
  //     bgColor(4, 2, 'rgb(255,247,177)')
  //     bgColor(2, 0, 'rgb(179,255,195)')

  //     function bgColor (Top, Height, Color) {
  //     ctx.fillStyle = Color;
  //     ctx.fillRect(left, y.getPixelForValue(Top), width, y.getPixelForValue(Height) - y.getPixelForValue(Top));
  //     }
  //   }
  // }
  // return(
  //     <Box>
  //        { this.state.isViewChart ? 
  //                 <Box sx={{ width: "70vw" }}>
  //                   <Line 
  //                   data={data} 
  //                   options={options}
  //                   plugins= {[chartBackground]}
  //                    />
  //                 </Box> : null  

  //         }
  //     </Box>
  //   )
  // }
  // viewChartPopupClose = () => {
  //   this.setState({
  //     isViewChart: false
  //   })
  // }
  msgClose(){
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }
  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message,
      BtnDisable : false
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message,
      BtnDisable : false
    })
  }
  render() {
    const { t } = this.props
    var { ipPatientData } = this.state
    let attender = {
      lineOne: t("AttenderName"),
      lineTwo: `${ipPatientData.attender_name ? ipPatientData.attender_name : '-'}`,
      lineFour: t('ContactNumber'),
      LineFive: `${ipPatientData.attender_mobile ? ipPatientData.attender_mobile : '-'}`
    }
    let consultant = {
      lineOne: t("ConsultantName"),
      lineTwo: `${ipPatientData.doctor_name ? ipPatientData.doctor_name : '-'}`,
    }
    return (
      
      <Box id="eMed_medication_Container" sx={{ backgroundColor: Colors.configHomeBg }}>
       <Grid container className="eMed_medication_Box" >
        <Stack className="eMed_medicationCard_header" direction="row" justifyContent="space-evenly" alignItems="center" spacing={1.2} style={{marginBottom: "0.2dvw"}}>
          <Stack className="eMed_recCard_div" sx={{ width: "23vw", backgroundColor: Colors.white }} >
            <CommonPatientDetails data={this.state.ipPatientData} showDetailed={true}/>
          </Stack>
          <CommonPatientCard details={attender} showDetailed={true}/>
          <ConsultantPatientCard name={consultant} width={"20dvw"}/>
        </Stack>
          <Grid container spacing = {2} className={'eMed_vital_Container'}>
            <Grid item xs={8} className={'eMed_vital_left'}>
              {this.renderLeftContent()}
            </Grid>
            <Grid item xs={4} className={'eMed_vital_right'}>
              {this.renderRightContent()}
            </Grid>
          </Grid>
        </Grid>
        {this.state.deletePopup ? <DeletePopup
                    DeletTitle={`${t("deleteMsg")} ${"Pain Chart"}?`}
                    deleteAlertPopupClose={this.popupClose.bind(this)}
                    removeData={this.deletePainLevel.bind(this)}
                /> : null}
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {/* {(this.state.isViewChart) ?
                    <CommonPopUp width={"75vw"}  height = { "90vh"}
                        backgroundColor={Colors.white}
                        popUpClose={this.viewChartPopupClose.bind(this)}
                        title={""}
                        component={this.renderChartComponent.bind(this)}
                    />
                    : null
                } */}
                <Loader loaderOpen={this.state.isLoader} />
               
      </Box>

    )
  }
}

export default withTranslation()(PainChart)
